import { BackendService } from './BackendService';
import { Payments } from '../types/paymentTypes';

export class PaymentsService {
  static async getPayments(
    dealId: string,
    downPayment: number,
    creditRating: string,
    pencilId: string,
    clientType: 'online' | 'instore',
    multipleLeaseTerms?: boolean,
  ) {
    const result = await BackendService.get<Payments>(
      `/payments/${clientType}/${dealId}`,
      {
        params: {
          downPayment,
          creditRating,
          pencilId,
          multipleLeaseTerms,
        },
      },
    );
    return result.data;
  }
}
